/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { ILeadApi } from '@boxx/messages-core';
import {
  IGBMConversationListApi,
  IGBMConversationMessageListApi,
} from '../models/GBMessages-api.properties';

export const TEST_LEAD_API_LIST: ILeadApi[] = [
  {
    id: 17,
    name: 'Carlos',
    message: 'Necesito ver si pueden dar clases en grupo',
    email: 'carlos@testmail.com',
    phone: '5556667789',
    timestamp: '2020-10-15 10:39:28',
    read_status: 'NEW',
  },
  {
    id: 18,
    name: 'Daniel Test',
    message: 'test',
    email: 'daniel@testemail.com',
    phone: '4567851235',
    timestamp: '2020-10-26 17:26:18',
    read_status: 'NEW',
  },
  {
    id: 19,
    name: 'Pedro',
    message: 'Prueba desde carretera M\u00e9xico Puebla ',
    email: 'pquinzanos@gmail.com',
    phone: '5555555555',
    timestamp: '2020-10-27 08:29:50',
    read_status: 'NEW',
  },
];

export const MOCK_REVIEWS_API_LIST = {
  reviews: [
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GipUQBibNi8HTSFzUxppjatobbPUIp_AGmh7ODrKQ=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Andrew GentlyWeeps',
      },
      starRating: 5,
      comment:
        // eslint-disable-next-line @typescript-eslint/quotes
        "(Translated by Google) The second time I went they treated me much better, thank you very much: P\nI'll keep testing the service :)\n\n(Original)\nLa segunda vez que fui me atendieron mucho mejor, muchas gracias :P\nSeguir\u00e9 probando el servicio :)",
      createTime: '2021-07-20T14:08:36.535Z',
      updateTime: '2021-07-20T14:08:36.535Z',
      reviewReply: { comment: 'xd', updateTime: '2021-09-01T20:10:16.201Z' },
      id: 'AbFvOql1QAZF0PRAjcDVXx1_o9HO8MyLOdwtwv-wBg-GrFAnN7mWsccIcPT9rCNmdWuxjVol6LrzqA',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GgHu5Oo2LTBv8JE4m1i9q9u2I3mxMNNB83u_p2e=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Juan Herrera',
      },
      starRating: 3,
      comment:
        '(Translated by Google) They take a long time to assist you\n\n(Original)\nSe tardan mucho en atenderte',
      createTime: '2021-05-14T18:09:16.565Z',
      updateTime: '2021-05-14T18:09:16.565Z',
      reviewReply: {
        comment:
          'Lamentamos tu experiencia negativa , ser\u00e1 un gusto atenderte',
        updateTime: '2021-05-14T20:18:10.851Z',
      },
      id: 'AbFvOqmC78Kb_E7Asc78f4q8aJXJntsMJaRKnfoVCOQTMA4qAvkr3PzBFZKvG5goen6AtM1IZQ4r7g',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14Ggn7Z2mt7zu9R39CDcxagllH-N0m0OUIfzITOU6=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Julio Eduardo Flores Cano',
      },
      starRating: 5,
      comment:
        '(Translated by Google) Excellent quality, service and attention. I will definitely be back!\n\n(Original)\nExcelente calidad, servicio y atenci\u00f3n. Sin duda volver\u00e9!',
      createTime: '2021-05-14T18:00:33.274Z',
      updateTime: '2021-05-14T18:00:33.274Z',
      id: 'AbFvOqlQhMgsTwaXimcRDAWOj5u69TpnuKHp3KNi697JJzni-WP9EnW5r43jDoU11QqlZxU1ISAv-g',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GimzFSUkDNLceEE-YAviXvoqNc87k7lSzkru6b6mA=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Manuel Alejandro Hernandez',
      },
      starRating: 5,
      comment:
        '(Translated by Google) Good service I recommend it .... !!!!!\n\n(Original)\nBuen servicio lo recomiendo....!!!!!',
      createTime: '2021-05-14T17:58:39.602Z',
      updateTime: '2021-05-14T17:58:39.602Z',
      id: 'AbFvOqkRgIEFKtz0bfaKIIbf-Gwl2TdO8lv5zf6sdDxgABruGjuORdNtf9_omb1R2Au80ZCjG83l3w',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GhHYdK2h-8cHEUv8uOlSXAoJ91HrjrKRfdwA9aM=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Andr\u00e9s Vergara Bahena',
      },
      starRating: 5,
      comment:
        '(Translated by Google) Excellent attention :)\n\n(Original)\nExcelente atenci\u00f3n :)',
      createTime: '2021-03-16T21:50:55.368Z',
      updateTime: '2021-03-16T21:50:55.368Z',
      reviewReply: {
        comment: 'Gracias por su preferencia! Siempre un gusto.',
        updateTime: '2021-05-13T16:53:52.900Z',
      },
      id: 'AbFvOqkrg79w8UNXJYBYyQCM2Yn_Kh169BlAVQjjxXtBP3ZOd_jK-lch5sOvMGiLy2W-TBrv3EkXvA',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GjawjyPA7nfoL4GH25gPPKaiF-NqbJN-G8SunQE=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Federico Rodriguez Cabrera',
      },
      starRating: 5,
      comment:
        '(Translated by Google) Excellent Personalized service!\n\n(Original)\nExcelente servicio Personalizado!',
      createTime: '2021-03-16T20:35:48.674Z',
      updateTime: '2021-03-16T20:35:48.674Z',
      reviewReply: {
        comment: 'Un placer atenderte',
        updateTime: '2021-05-13T18:12:34.842Z',
      },
      id: 'AbFvOqkG2h_OsXY2JmAP88Eo_hY-lCfx3oOGwA-RIIbSyzApYDvA9qOSOlauhMu3PnjzM7P8NoDRoQ',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GilChftFba4vvBI9PCRaEvau3xIa5nXuUIPHI0j=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Christian Hern\u00e1ndez Landa',
      },
      starRating: 5,
      comment:
        '(Translated by Google) I liked that they treated me well and quickly, highly recommended.\n\n(Original)\nMe gust\u00f3 que me atendieran bien y r\u00e1pido, muy recomendables.',
      createTime: '2021-03-16T20:34:07.391Z',
      updateTime: '2021-03-16T20:34:07.391Z',
      id: 'AbFvOqmGwQn73VgSEsWQrtnCGf7RZys9YmVozEGuOZz37NlD5DkjHkhwZ6_kcSkajQ0uzPmg4MxhxQ',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14Gg73CWjV5hyA3oPWFO7yqKxkrHTIYScL-C36fu-JP0=s120-c-c0x00000000-cc-rp-mo-ba3-br100',
        displayName: 'Evelyn Rivas',
      },
      starRating: 4,
      comment:
        '(Translated by Google) Thanks for your help!\n\n(Original)\nGracias por su ayuda!',
      createTime: '2021-03-16T07:42:02.701Z',
      updateTime: '2021-03-16T07:42:02.701Z',
      id: 'AbFvOql4IMdsD7GVhCnaaglvpTJZ02UfdSwrbR1Ro7RVn8wjdmlBanj-augg4Q8OltLmUG6JP83RTw',
    },
    {
      reviewer: {
        profilePhotoUrl:
          'https://lh3.googleusercontent.com/a-/AOh14GiTYD1WKpyhwxxRR-Zn0wphVm6CyhfFWimg3-9MDA=s120-c-c0x00000000-cc-rp-mo-br100',
        displayName: 'Daniel Moya',
      },
      starRating: 5,
      comment:
        '(Translated by Google) great service !!\n\n(Original)\nbuenisimo servicio!!',
      createTime: '2021-03-11T19:09:52.862Z',
      updateTime: '2021-03-11T19:09:52.862Z',
      reviewReply: {
        comment: 'Thank you !',
        updateTime: '2021-03-16T18:48:41.593Z',
      },
      id: 'AbFvOqlf3AdAw8YziojukBOJkUjXpP8UYZFL4IFRkxL9IdoX2SWJLfjZNKWBqj7dlQ1I2Z-0zchq6g',
    },
  ],
  averageRating: 4.7,
  totalReviewCount: 9,
};

export const TEST_GBM_CONVERSATION_LIST: IGBMConversationListApi = {
  id: '9a0e97b4-ee52-495b-bb63-6f5d2d63e58a',
  type: 'messages',
  attributes: [
    {
      id: '1',
      business_id: '17',
      platform: 'google',
      conversationId: 'e2ad210d-ed81-4e15-94c2-a76434ca8d62',
      created_at: '2021-04-16 03:07:12',
      updated_at: '2021-04-16 03:07:12',
    },
    {
      id: '2',
      business_id: '17',
      platform: 'google',
      conversationId: '5f2c94b8-552f-44a9-8424-dd9542734d06',
      created_at: '2021-04-16 09:27:00',
      updated_at: '2021-04-16 09:27:00',
    },
  ],
};

const conv1 = [
  {
    id: '1',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Es la prueba nocturna',
    created_at: '2021-04-16 03:07:12',
  },
  {
    id: '2',
    conversation_id: '1',
    type: 'owner',
    name: 'Mosshi',
    message: 'Que Onda!',
    created_at: '2021-04-16 03:21:50',
  },
  {
    id: '3',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Muy bien :)',
    created_at: '2021-04-16 03:23:50',
  },
  {
    id: '4',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Muy bien :)',
    created_at: '2021-04-16 03:23:50',
  },
  {
    id: '5',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Muy bien :)',
    created_at: '2021-04-16 03:23:50',
  },
  {
    id: '6',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Muy bien :)',
    created_at: '2021-04-16 03:23:50',
  },
  {
    id: '7',
    conversation_id: '1',
    type: 'client',
    name: 'jok3rcit0',
    message: 'Muy bien :)',
    created_at: '2021-04-16 03:23:50',
  },
  {
    id: '8',
    conversation_id: '1',
    type: 'owner',
    name: 'Mosshi',
    message: 'Bye',
    created_at: '2021-04-16 03:21:50',
  },
];

const conv2 = [
  {
    id: '1',
    conversation_id: '2',
    type: 'client',
    name: 'KingAndrew',
    message: 'Esta es una prueba fake',
    created_at: '2021-04-16 03:07:12',
  },
  {
    id: '2',
    conversation_id: '2',
    type: 'owner',
    name: 'Mosshi',
    message: 'Ok ta bien!',
    created_at: '2021-04-16 03:21:50',
  },
  {
    id: '3',
    conversation_id: '2',
    type: 'client',
    name: 'KingAndrew',
    message: 'Weno bye!',
    created_at: '2021-04-16 03:23:50',
  },
];

export const TEST_GBMMESSAGE_LIST: IGBMConversationMessageListApi = {
  id: 972813,
  type: 'messages',
  attributes: [...conv1, ...conv2],
};
